/**
 * A single-value filter's value as the string its control expects. Query
 * mode keeps every value of a key, so it reads the first one. Saved filters
 * can hold numbers, such as a workflow's `riskScoreGte`, so a finite number
 * reads as its string form.
 */
export const readSingleFilterValue = (raw: unknown, mode: string): string => {
  const value = mode === 'query' && Array.isArray(raw) ? raw[0] : raw;
  if (typeof value === 'string') {
    return value;
  }
  if (typeof value === 'number' && Number.isFinite(value)) {
    return String(value);
  }
  return '';
};
